import { Currency } from './currency';
import { currenciesAll } from '@studyportals/static-domain-data/currencies/currencies';

class CurrencyPresenter {
	public all(): Promise<readonly Currency[]> {
		return Promise.resolve(currenciesAll.map((c) => new Currency(c.iso, `${c.iso} - ${c.name}`)));
	}
}

export default new CurrencyPresenter();
